<template>
  <div class="mt-2">
    <div>
      <CRow class="widget-v2">
        <CCol md="9">
          <CRow>
            <div
              class="col-md-4"
              v-for="({ id, label, value }, index) in getCandidateData.stats"
              :key="index"
            >
              <div
                class="card card-raised border-start border-4"
                :style="`border-color: ${getTheme(id).raw_color}`"
              >
                <div class="card-body pl-4 pr-4">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <div class="me-2">
                      <div class="display-5">{{ value }}</div>
                      <div class="card-text" :style="getTheme(id).text_color">
                        {{ label }}
                      </div>
                    </div>
                    <i
                      v-if="iconHide(id)"
                      :class="getTheme(id).src"
                      style="font-size: 27px"
                      :style="getTheme(id).text_color"
                    />
                    <img
                      v-else
                      :src="getTheme(id).src"
                      class="icon-img"
                      :style="getTheme(id).text_color"
                    />
                  </div>
                </div>
              </div>
            </div>
          </CRow>
        </CCol>
        <CCol md="3">
          <CRow>
            <div
              class="col-md-12 border-left"
              v-for="(
                { id, label, value }, index
              ) in getCandidateData.totalData"
              :key="index"
            >
              <div
                class="card card-raised border-start border-4"
                :style="`border-color: ${getTheme(id).raw_color}`"
              >
                <div class="card-body pl-4 pr-4">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <div class="me-2">
                      <div class="display-5">{{ value }}</div>
                      <div class="card-text" :style="getTheme(id).text_color">
                        {{ label }}
                      </div>
                    </div>
                    <i
                      v-if="iconHide(id)"
                      :class="getTheme(id).src"
                      style="font-size: 27px"
                      :style="getTheme(id).text_color"
                    />
                    <img
                      v-else
                      :src="getTheme(id).src"
                      class="icon-img"
                      :style="getTheme(id).text_color"
                    />
                  </div>
                </div>
              </div>
            </div>
          </CRow>
        </CCol>
      </CRow>
    </div>
    <CCard>
      <CCardHeader>
        <CRow class="card-header-title d-flex align-items-center pl-3">
          <h5 class="text-primary">Full & Short Registrations</h5>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="6">
            <div class="position-relative" style="height: 250px">
              <GPie
                :data="getCandidateFullShortStats"
                :keys="['Full', 'Short']"
                :height="'220px'"
              />
            </div>
          </CCol>
          <CCol md="6">
            <div class="position-relative mx-auto" style="height: 250px">
              <BasicBar :data="getCandidateFullShortTrend" />
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>
        <h5 class="text-primary d-block">Registered Candidates by Country</h5>
      </CCardHeader>
      <CCardBody>
        <div class="d-flex justify-content-center align-items-center" style="width: 100%; height: 500px">
          <!-- <GeoChart
            v-if="getCandidateByCountry.length > 0"
            :candidates="getCandidateByCountry"
          /> -->
          <iframe
            src="/map/marketplace.html"
            width="1366"
            height="550"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import Tile from "@/containers/Dashboard/RecruiterDashBoard/Tile";
import ScratchPad from "@/containers/Dashboard/RecruiterDashBoard/ScratchPad";
import CalendarPad from "@/containers/Dashboard/RecruiterDashBoard/CalendarPad";
import CandidateJobAlert from "@/containers/Dashboard/RecruiterDashBoard/Alert1-CandidateJobStatus";
import Transactions from "@/containers/Dashboard/RecruiterDashBoard/Transactions";
import RAGAlert from "@/containers/Dashboard/RecruiterDashBoard/Alert2-RAG";
import CandidateCommunication from "@/containers/Dashboard/RecruiterDashBoard/CandidateCommunication";
import { Role, getScope, CONSTANT as CONST } from "@/helpers/helper";
import CustomPieChart from "@/components/Dashboard/CustomPieChart";
import Bar from "@/components/reusable/Charts/Bar.vue";
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import GeoChart from "@/components/reusable/Charts/GeoChart.vue";
import GPie from "@/components/reusable/Charts/GPie.vue";

export default {
  name: "MarketPlaceDashboard",
  components: {
    Tile,
    ScratchPad,
    CalendarPad,
    CandidateJobAlert,
    RAGAlert,
    CandidateCommunication,
    CustomPieChart,
    Transactions,
    Bar,
    BasicBar,
    GeoChart,
    GPie,
  },
  data() {
    return {
      Role,
      currentUserRole: getScope(),
      countryData: [
        {
          country_name: "Afghanistan",
          count: 3,
        },
        {
          country_name: "Albania",
          count: 3,
        },
        {
          country_name: "Algeria",
          count: 4,
        },
        {
          country_name: "Andorra",
          count: 2,
        },
        {
          country_name: "Angola",
          count: 1,
        },
        {
          country_name: "Antigua and Barbuda",
          count: 1,
        },
        {
          country_name: "Argentina",
          count: 1,
        },
        {
          country_name: "Armenia",
          count: 1,
        },
        {
          country_name: "Australia",
          count: 32,
        },
        {
          country_name: "Austria",
          count: 1,
        },
        {
          country_name: "Bahrain",
          count: 1,
        },
        {
          country_name: "Bangladesh",
          count: 2,
        },
        {
          country_name: "Barbados",
          count: 1,
        },
        {
          country_name: "Belgium",
          count: 8,
        },
        {
          country_name: "Bermuda",
          count: 1,
        },
        {
          country_name: "Brazil",
          count: 1,
        },
        {
          country_name: "Canada",
          count: 27,
        },
        {
          country_name: "Cape Verde",
          count: 1,
        },
        {
          country_name: "China",
          count: 3,
        },
        {
          country_name: "Czech Republic",
          count: 1,
        },
        {
          country_name: "Denmark",
          count: 1,
        },
        {
          country_name: "Egypt",
          count: 20,
        },
        {
          country_name: "Ethiopia",
          count: 1,
        },
        {
          country_name: "France",
          count: 10,
        },
        {
          country_name: "Germany",
          count: 19,
        },
        {
          country_name: "Ghana",
          count: 3,
        },
        {
          country_name: "Greece",
          count: 7,
        },
        {
          country_name: "Grenada",
          count: 1,
        },
        {
          country_name: "Haiti",
          count: 1,
        },
        {
          country_name: "Hong Kong",
          count: 1,
        },
        {
          country_name: "Iceland",
          count: 1,
        },
        {
          country_name: "India",
          count: 362,
        },
        {
          country_name: "Indonesia",
          count: 1,
        },
        {
          country_name: "Iran",
          count: 1,
        },
        {
          country_name: "Iraq",
          count: 3,
        },
        {
          country_name: "Ireland",
          count: 50,
        },
        {
          country_name: "Italy",
          count: 104,
        },
        {
          country_name: "Japan",
          count: 1,
        },
        {
          country_name: "Jordan",
          count: 7,
        },
        {
          country_name: "Kyrgyzstan",
          count: 1,
        },
        {
          country_name: "Lebanon",
          count: 8,
        },
        {
          country_name: "Malta",
          count: 1,
        },
        {
          country_name: "Nepal",
          count: 2,
        },
        {
          country_name: "Netherlands",
          count: 3,
        },
        {
          country_name: "New Zealand",
          count: 2,
        },
        {
          country_name: "Nigeria",
          count: 13,
        },
        {
          country_name: "Pakistan",
          count: 17,
        },
        {
          country_name: "Palestine",
          count: 1,
        },
        {
          country_name: "Philippines",
          count: 107,
        },
        {
          country_name: "Poland",
          count: 1,
        },
        {
          country_name: "Portugal",
          count: 11,
        },
        {
          country_name: "Romania",
          count: 2,
        },
        {
          country_name: "Saint Martin/Sint Maarten",
          count: 2,
        },
        {
          country_name: "Saint Vincent and the Grenadines",
          count: 2,
        },
        {
          country_name: "Saudi Arabia",
          count: 4,
        },
        {
          country_name: "Somalia",
          count: 2,
        },
        {
          country_name: "South Africa",
          count: 4,
        },
        {
          country_name: "Spain",
          count: 3,
        },
        {
          country_name: "Sri Lanka",
          count: 3,
        },
        {
          country_name: "Sudan",
          count: 5,
        },
        {
          country_name: "Sweden",
          count: 2,
        },
        {
          country_name: "Switzerland",
          count: 1,
        },
        {
          country_name: "Syria",
          count: 1,
        },
        {
          country_name: "Tunisia",
          count: 2,
        },
        {
          country_name: "Turkey",
          count: 3,
        },
        {
          country_name: "United Arab Emirates",
          count: 28,
        },
        {
          country_name: "United Kingdom",
          count: 407,
        },
        {
          country_name: "United States",
          count: 88,
        },
        {
          country_name: "Uzbekistan",
          count: 101,
        },
      ],
    };
  },
  computed: {
    getCandidateData() {
      return {
        stats: [
          { id: 1, label: "Physician", value: 261 },
          { id: 4, label: "Dentist", value: 14 },
          { id: 2, label: "Nursing and Midwiferys", value: 474 },
          { id: 3, label: "Allied Health", value: 39 },
          { id: 6, label: "Non-Clinical Roles (i.e. Non-Health)", value: 18 },
          { id: 5, label: "Social Care", value: 5 },
        ],
        totalData: [
          {
            id: 9,
            label: "Total Candidates",
            value: 811,
          },
          {
            id: 8,
            label: "Total Jobs Posted",
            value: 39,
          },
        ],
      };
    },
    getCandidateFullShortStats() {
      return [
        {
          name: "Full",
          value: 800,
          backgroundColor: "#70dbdb",
          borderColor: "#02dbdb",
        },
        {
          name: "Short",
          value: 24,
          backgroundColor: "#e381da",
          borderColor: "#b000a0",
        },
      ];
    },
    getCandidateFullShortTrend() {
      const monthYearSummary = [
        { month_year: "May 2025", full_registered_count: 2, short_registered_count: 1 },
        { month_year: "June 2025", full_registered_count: 2, short_registered_count: 0 },
        { month_year: "July 2025", full_registered_count: 6, short_registered_count: 3 },
        { month_year: "August 2025", full_registered_count: 3, short_registered_count: 2 },
        { month_year: "September 2025", full_registered_count: 2, short_registered_count: 0 },
        { month_year: "October 2025", full_registered_count: 3, short_registered_count: 13 },
      ];

      return [
        {
          name: "Full Registration",
          backgroundColor: "#39e3c9",
          borderColor: "#00ebc7",
          values: monthYearSummary.map((d) => ({
            name: d.month_year,
            value: d.full_registered_count,
          })),
        },
        {
          name: "Short Registration",
          backgroundColor: "#ffb347",
          borderColor: "#ff9800",
          values: monthYearSummary.map((d) => ({
            name: d.month_year,
            value: d.short_registered_count,
          })),
        },
      ];
    },
    getCandidateByCountry() {
      const countrySummary = this.countryData || [];
      return countrySummary?.map((data) => {
        return {
          name: data.country_name,
          value: data.count,
          country: data.country_name,
          count: data.count,
        };
      });
    },
  },
  methods: {
    iconHide(id) {
      if (id == 8 || id == 9) return false;
      return true;
    },
    getTheme(id) {
      let src = "";
      let color = "";
      switch (id) {
        case 0:
          src = "fas fa-clinic-medical";
          color = "#35c792;";
          break;
        case 1:
          src = "fas fa-user-md";
          color = "#8a08a2;";
          break;
        case 2:
          src = "fas fa-user-nurse";
          color = "#1973e8";
          break;
        case 3:
          src = "fas fa-notes-medical";
          color = "#61892F;";
          break;
        case 4:
          src = "fas fa-tooth";
          color = "#e01f66;";
          break;
        case 5:
          src = "fas fa-prescription-bottle-alt";
          color = "#B23850;";
          break;
        case 6:
          src = "fas fa-hospital";
          color = "#895061;";
          break;
        case 8:
          src = "img/job.png";
          color = "#8a08a2;";
          break;
        case 9:
          src = "img/group.png";
          color = "#dd3651;";
          break;
        case 10:
          src = "fa-solid fa-chalkboard-user";
          color = "#35c792;";
          break;
        case 11:
          src = "fa-solid fa-user-group";
          color = "#8a08a2;";
          break;
        case 12:
          src = "fa-solid fa-graduation-cap";
          color = "#61892F;";
          break;
        default:
          src = "fas fa-user-shield";
          color = "#9117a8;";
      }
      return {
        src: src,
        bg_color: "background-color: " + color,
        color: "color: " + color,
        text_color: "color: " + color,
        raw_color: `${color.replace(";", "")} !important;`,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 450px) {
  .tile {
    margin-top: 20px;
  }
}

.maintainwidth {
  min-width: 158px;
}
.text-value {
  width: max-content;
  img,
  i {
    vertical-align: middle;
    border-style: none;
    float: left;
    height: 27px;
    font-size: 27px;
    margin-top: 6px;
    margin-right: 16px;
  }
}
.widget-v2 {
  .border-4 {
    --bs-border-width: 4px;
  }
  .shadow-1,
  .popover,
  .card-raised {
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  }
  .small,
  .toast,
  .card,
  .alert {
    letter-spacing: 0.0178571429em;
    font-size: 0.875rem;
  }
  .card {
    line-height: 1.25rem;
    color: #000;
  }
  .card-raised {
    border: none !important;
  }
  .card-body {
    flex: 1 1 auto;
    padding: 1rem 1rem;
  }
  .border-start {
    border-left: 4px solid #e0e0e0 !important;
  }
  // .border-primary {
  //   border-color: rgba(98, 0, 234, 1) !important;
  // }
  .icon-i {
    font-size: 27px;
  }
  .icon-img {
    height: 27px;
    font-size: 27px;
    margin-top: 6px;
    margin-right: 16px;
  }
  .card-text {
    font-size: 13px;
  }
  .display-5 {
    font-size: 20px;
  }
}
</style>
